<template>
  <div class="container-xl mt-4">
    <div class="row row-cards">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">收款協議設定</h3>
          </div>
          <div class="card-body">
            <div class="alert alert-warning">
              使用波場收款，速度更快，交易手續費更低
            </div>
            <div
              :class="
                alertStatus === 'success'
                  ? 'alert alert-success'
                  : 'alert alert-danger'
              "
              v-show="alertStatus !== ''"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <form pb-autologin="true" autocomplete="off">
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">收款協議</label>
                <div>
                  <label class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      v-model="paymentProtocol"
                      :disabled="!checkPermission"
                      value="tronUSDT"
                    />
                    <span class="form-check-label">Tron TRC20 USDT (波場)</span>
                  </label>
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-6"></div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <router-link
                        to="assets"
                        class="btn btn-outline-secondary w-100"
                      >
                        返回
                      </router-link>
                    </div>
                    <div class="col-6">
                      <button
                        type="submit"
                        class="btn btn-outline-primary w-100"
                        @click.prevent="setPaymentProtocol"
                        :disabled="!checkPermission"
                      >
                        設定
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      alertMsg: "",
      alertStatus: "",
      token: "",
      key: "",
      paymentProtocol: "tronUSDT",
      checkPermission: false,
      firstTimeWithdrawSetting: false,
    };
  },
  methods: {
    async setPaymentProtocol() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/paymentProtocolSetting`;
      const vm = this;
      try {
        const res = await this.$http.patch(
          api,
          { paymentProtocol: vm.paymentProtocol },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );
        if (!res.data.data) {
          throw "error";
        }
        this.alertStatus = "success";
        this.alertMsg = "設定成功";
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
        this.alertStatus = "error";
        this.alertMsg = "錯誤";
      }
    },
    async getSetting() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/setting`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.paymentProtocol = !res.data.data.merchantSetting.paymentProtocol
          ? "tronUSDT"
          : res.data.data.merchantSetting.paymentProtocol;
        this.checkPermission = true;
      } catch (err) {
        if (err.response.status === 401) {
          this.alertStatus = "error";
          this.alertMsg = "請等待驗證完成";
        } else {
          this.alertStatus = "error";
          this.alertMsg = "無法取得資訊";
        }
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getSetting();
  },
};
</script>
